<template src="./template.html"></template>

<script>
    /* eslint-disable */

    import { mapGetters } from 'vuex';
    import api from '../../../util/api';
    import wordingService from './wordingService';

    /* eslint-disable no-console */
    export default {
        name: 'Wording',
        data () {
            return {
                wording: [],
                wordingTableEmpty: false,
                keyFieldEnabled: false,
                deleteBtnEnabled: false,
                // add warnText as data attribute because {{}} can not be added as text in html
                warnText: 'Die Textstellen in doppelten geschweiften Klammern ( {{datum}}, {{status_text}} und {{speed}} ) werden vor der Auslieferung\n' +
                '                    ans Front-End ersetzt und dürfen nicht\n' +
                '                    geändert werden.',
                newWord: {
                    supplier_id: '',//this.$store.state.auth.current_user.supplier_id,
                    key: '',
                    label: '',
                    //supplier_name:'',
                },
                createBtnText: 'Speichern',
            };
        },
        computed: {
            ...mapGetters(['get_current_user', 'user_is_admin']),
        },
        created () {
             wordingService.list().then((resp) => {
                 this.wording = this.prepareWording(resp.data);
             });
        },
        methods: {
            prepareWording (data) {
                // return data;
                return data.map((word) => {
                    const tempWord = word;
                    // add additional parameters to the words
                    tempWord.supplier_name = 'Base wording';
                    if (word.supplier) {
                        tempWord.supplier_name = word.supplier.supplier_name;
                        tempWord.supplier_id = word.supplier.id;
                    }
                    tempWord.submitLabel = 'Speichern';
                    tempWord.changed = false;
                    tempWord.btnIcon = '';
                    tempWord.btnType = 'primary';
                    return tempWord;
               });
            },
            submitUpdateForm (index, wordingKey) {
                const word = this.wording.filter(item => item.key === wordingKey)[0];
                const url = '/wording/update';
                this.wording[index].submitLabel = 'Speichern...';

                return api.put(url, word)
                    .then(() => {
                        // show success button
                        this.wording[index].btnIcon = 'el-icon-success';
                        this.wording[index].btnType = 'success';
                        this.wording[index].submitLabel = 'Gespeichert';
                        setTimeout(() => {
                            // revert button to normal and hide it
                            this.wording[index].changed = false;
                            this.wording[index].btnIcon = '';
                            this.wording[index].btnType = 'primary';
                            this.wording[index].submitLabel = 'Speichern';
                        }, 1500);
                    })
                    .catch(() => {
                        // if an error occurs show error button
                        this.wording[index].submitLabel = 'Fehlgeschlagen';
                        this.wording[index].btnIcon = 'el-icon-error';
                        this.wording[index].btnType = 'danger';
                    });
            },
            submitCreateForm () {
                const url = '/wording/create';
                this.createBtnText = 'Speichern...';
                return api.post(url, this.newWord)
                    .then((response) => {
                        // add new word to wording
                        const word = response.data;
                        word.supplier_name = word.supplier ? word.supplier.supplier_name : 'Base wording';
                        word.changed = false;
                        word.btnIcon = '';
                        word.btnType = 'primary';
                        word.submitLabel = 'Speichern';
                        this.wording.push(word);
                        // clear the create form fields
                        this.newWord.key = null;
                        this.newWord.label = null;
                        this.createBtnText = 'Speichern';
                    });
            },
            submitDeleteForm (index, wordingId) {
                const url = `/wording/delete/${wordingId}`;
                return api.delete(url)
                    .then(() => {
                        this.wording.splice(index, 1);
                    });
            },
            hasChanged (index) {
                this.wording[index].changed = true;
            },
        },
    };
</script>

<style scoped>
    .card-header {
        margin: 20px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/wording/Wording.vue